import { render, staticRenderFns } from "./Preferential.vue?vue&type=template&id=5394ceae"
import script from "./Preferential.vue?vue&type=script&lang=js"
export * from "./Preferential.vue?vue&type=script&lang=js"
import style0 from "./Preferential.vue?vue&type=style&index=0&id=5394ceae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports